import { IProductBranch } from '../models/ivb_product_branch'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

export const getIVBConfig = () =>
  Api<IApiResponse<IProductBranch[]>>('GET', 'branches', BaseUrl.Request)
